/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ToggleProductDescriptionEnabledDTO
 */
export interface ToggleProductDescriptionEnabledDTO {
  /**
   *
   * @type {boolean}
   * @memberof ToggleProductDescriptionEnabledDTO
   */
  enabled: boolean;
}

/**
 * Check if a given object implements the ToggleProductDescriptionEnabledDTO interface.
 */
export function instanceOfToggleProductDescriptionEnabledDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "enabled" in value;

  return isInstance;
}

export function ToggleProductDescriptionEnabledDTOFromJSON(json: any): ToggleProductDescriptionEnabledDTO {
  return ToggleProductDescriptionEnabledDTOFromJSONTyped(json, false);
}

export function ToggleProductDescriptionEnabledDTOFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ToggleProductDescriptionEnabledDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    enabled: json["enabled"]
  };
}

export function ToggleProductDescriptionEnabledDTOToJSON(value?: ToggleProductDescriptionEnabledDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    enabled: value.enabled
  };
}
